import { ProgressContextProvider } from "./ProgressContext"
import { SelectedCodeProvider } from "./SelectedCodeContext"
import { SelectedGroupProvider } from "./SelectedGroupContext"
import { SelectedUsersProvider } from "./SelectedUserContext"
import { ModeContextProvider } from "./ModeContext"
import { FunctionNameContextProvider } from "./FunctionName"

export const DashboardProviders = ({ children }) => {
  return (
    <SelectedGroupProvider>
      <ProgressContextProvider>
        <SelectedUsersProvider>
          <SelectedCodeProvider>
            <ModeContextProvider>
              <FunctionNameContextProvider>
                {children}
              </FunctionNameContextProvider>
            </ModeContextProvider>
          </SelectedCodeProvider>
        </SelectedUsersProvider>
      </ProgressContextProvider>
    </SelectedGroupProvider>
  )
}